import { useState, useEffect } from 'react'
import { useAnaliseCadavericaLocal } from 'hooks/useAnaliseCadavericaLocal'
import { useCadaverService } from 'hooks/useCadaverService'

export const useFormAnaliseCadavericaLocal = ({ idCadaver, fetchCadaveres, idExameRealizado, onConfirmSuccess }) => {
  const analiseCadavericaService = useAnaliseCadavericaLocal()
  const cadaverService = useCadaverService()

  const [processandoAnaliseCadaverica, setProcessandoAnaliseCadaverica] = useState(false)
  const [processandoConfirmacao, setProcessandoConfirmacao] = useState(false)
  const [analiseCadavericaLocal, setAnaliseCadavericaLocal] = useState({})
  const [lesoes, setLesoes] = useState([])

  const [values, setValues] = useState({
    localizacao: '',
    posicao: '',
    posicaoInputText: '',
    cicatrizes: '',
    tatuagens: '',
    vestimentas: '',
  })

  const [errors, setErrors] = useState({})

  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('localizacao' in fieldValues) {
      temp.localizacao = fieldValues.localizacao?.trim() ? '' : 'A localização do cadáver na cena do caso é obrigatória'
    }
    if ('posicao' in fieldValues) {
      temp.posicao = fieldValues.posicao ? '' : 'A posição do cadáver é obrigatória'
    }
    setErrors(temp)
    return Object.values(temp).every((x) => x === '')
  }

  useEffect(() => {
    const fetchAnalise = async () => {
      const response = await analiseCadavericaService.listarAnaliseCadavericaLocalDeExame(
        idCadaver,
        idExameRealizado,
        setProcessandoAnaliseCadaverica
      )
      setAnaliseCadavericaLocal(response || {})
    }
    fetchAnalise()
  }, [idCadaver, idExameRealizado])

  useEffect(() => {
    if (analiseCadavericaLocal && analiseCadavericaLocal.id) {
      setValues({
        localizacao: analiseCadavericaLocal.localizacao || '',
        posicao: analiseCadavericaLocal.posicao || '',
        posicaoInputText: analiseCadavericaLocal.posicaoInputText || '',
        cicatrizes: analiseCadavericaLocal.cicatrizes || '',
        tatuagens: analiseCadavericaLocal.tatuagens || '',
        vestimentas: analiseCadavericaLocal.vestimentas || '',
        id: analiseCadavericaLocal.id,
      })
    }
  }, [analiseCadavericaLocal])

  const handleChange = (e) => {
    const { name, value } = e.target
    setValues((prev) => ({ ...prev, [name]: value }))
    validate({ [name]: value })
  }

  const handleAutocompleteChange = (name, newValue) => {
    setValues((prev) => ({ ...prev, [name]: newValue }))
    validate({ [name]: newValue })
  }

  const handleSalvarInformacoesCadaver = async () => {
    if (!validate()) return
    setProcessandoConfirmacao(true)
    try {
      await analiseCadavericaService.setarAnaliseCadavericaLocalDeExameRealizado(
        idCadaver,
        idExameRealizado,
        values
      )
      await cadaverService.setarLesoesCadaver(idCadaver, idExameRealizado, lesoes)
      fetchCadaveres()
      if (onConfirmSuccess) {
        onConfirmSuccess()
      }
    } catch (error) {
      console.error(error)
    } finally {
      setProcessandoConfirmacao(false)
    }
  }

  const hasError = (field) => {
    return !!errors[field]
  }

  return {
    processandoAnaliseCadaverica,
    processandoConfirmacao,
    values,
    errors,
    handleChange,
    handleAutocompleteChange,
    handleSalvarInformacoesCadaver,
    hasError,
    setLesoes,
  }
}
